import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import css from './Label.module.css';

const Label = (props) => {
	const classes = props.classes ? [css.Label, ...props.classes] : [css.Label];
	return (
		<div className={classes.join(' ')}>{props.text}</div>
	);
};

Label.propTypes = {
	text: PropTypes.any.isRequired,
	classes: PropTypes.any
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: (value) => dispatch(FN(value)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Label);